<template>
    <div class="w-full bg-white shadow-lg">
        <div class="flex p-1 justify-between text-center">
            <table class="w-full border-collapse border-gray-700 border-slate-700" style="margin-top: 10px;">
                <tbody class="bg-white">
                    <tr>
                        <td>
                            <div class="pb-2 pr-0 w-full lg:w-full">
                                <img src="/images/logo.png" style="height: 60px; display: block; margin-left: auto; margin-right: auto;"/>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="w-full items-center" style="margin-top: 6px; margin-bottom: 10px;">
            <h2 class="font-bold text-center" style="margin-bottom: 4px;">
                Welcome to the Moko Family!
            </h2>
            <h6 class="items-center text-center"><i>We are thrilled to be a part of your home!</i></h6>
        </div>
        <div class="flex p-1 justify-between" style="margin-top: 30px;">
            <table class="w-full border-collapse border-0 border-gray-700 border-slate-700">
                <tbody class="bg-white">
                    <tr>
                        <td>
                            <div class="pb-2 pr-0 w-full lg:w-full">
                                <h2 class="font-bold text-orange-400" style="margin-bottom: 4px;">
                                    CUSTOMER INFORMATION:
                                </h2>
                                <p style="line-height: 24px;">{{ customer.name }}</p>
                                <p style="line-height: 24px;">{{ customer.phone }}</p>
                                <p style="line-height: 24px;">{{ customer.email }}</p>
                                <p style="line-height: 24px;">{{ customer.city }},</p>
                                <p style="line-height: 24px;">{{ customer.region }}</p>
                                <p style="margin-top: 30px;">Dear {{ customer.name }},</p>
                                <p style="margin-top: 30px; line-height: 20px;">
                                    This is a match made in heaven! We knew right from the start
                                    that you were Mok-terial and can not wait to get you Mokofied!
                                    Please check your order <strong>{{ customer.order_no }}</strong> below and let us know in case of any changes.
                                    Your order will tentatively be ready by <strong>{{ customer.delivery_date }}</strong>. Someone from our
                                    team will contact you when it's ready to come home.
                                </p>
                                <h2 class="font-bold text-orange-400" style="margin-top: 30px;">
                                    ORDER DETAILS:
                                </h2>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="flex p-1 justify-between" style="margin-top: 15px;">
            <table class="whitespace-nowrap w-full border-collapse border-gray-700 border-slate-700">
                <tr class="text-left font-bold">
                    <th class="pb-3 pt-3 px-3">Part No.</th>
                    <th class="pb-3 pt-3 px-3">Part Description</th>
                    <th class="pb-3 pt-3 px-3">Qty</th>
                    <th class="pb-3 pt-3 px-3">Unit Cost</th>
                    <th class="flex items-end px-3 justify-end">Total Amount</th>
                </tr>
                <tr  v-for="(item, index) in details" :key="item.id">
                    <td class="w-px border-t pb-3 pt-3">
                        <span class="flex items-left px-3">{{ item.sku }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3" style="word-wrap: break-word !important; word-break: break-all !important; white-space: normal">
                        <span class="flex items-left px-3">{{ item.description }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                        <span class="flex items-center px-3">{{ item.quantity }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                        <span class="flex items-center px-3">{{ item.untit_cost }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                        <span class="flex items-end px-3 items-end justify-end">{{ item.amount }}</span>
                    </td>
                </tr>
                <tr v-if="customer.delivery_fees">
                    <td class="pb-3 pt-3  border-t border-b"><span class="flex items-center px-3">Transport</span></td>
                    <td class="pb-3 pt-3  border-t border-b" colspan="3"></td>
                    <td class="w-px pb-3 pt-3  border-t border-b">
                        <span class="flex items-end px-3 items-end justify-end">{{ customer.transport }}</span>
                    </td>
                </tr>
                <tr v-if="customer.voucher_info && customer.voucher_info.code">
                    <td class="pb-3 pt-3  border-t border-b"><span class="flex items-center px-3">Voucher Code #</span></td>
                    <td class="pb-3 pt-3  border-t border-b">
                        <span class="flex items-center px-3">
                            {{ customer.voucher_info.code }} - {{ customer.voucher_info.value }} {{ customer.voucher_info.type === 'Percentage' ? '%' : '' }}
                        </span>
                    </td>
                    <td class="pb-3 pt-3  border-t border-b"></td>
                    <td class="pb-3 pt-3  border-t border-b"></td>
                    <td class="pb-3 pt-3  border-t border-b">
                        <span class="flex items-end px-3 items-end justify-end">({{ customer.voucher_info.voucher_amount }})</span>
                    </td>
                </tr>
                <tr>
                    <td class="pb-3 pt-3  border-t border-b" />
                    <td class="pb-3 pt-3  border-t border-b" />
                    <td class="pb-3 pt-3  border-t border-b" />
                    <td class="pb-3 pt-3  border-t border-b">Sub Total</td>
                    <td class="pb-3 pt-3  border-t border-b">
                        <span class="flex items-end px-3 items-end justify-end">{{ customer.sub_total }}</span>
                    </td>
                </tr>
                <tr>
                    <td class="pb-3 pt-3  border-t border-b" />
                    <td class="pb-3 pt-3  border-t border-b" />
                    <td class="pb-3 pt-3  border-t border-b" />
                    <td class="pb-3 pt-3  border-t border-b">VAT Amount</td>
                    <td class="pb-3 pt-3  border-t border-b">
                        <span class="flex items-end px-3 items-end justify-end">{{ customer.vat }}</span>
                    </td>
                </tr>
                <tr>
                    <td class="pb-3 pt-3  border-t border-b" />
                    <td class="pb-3 pt-3  border-t border-b" />
                    <td class="pb-3 pt-3  border-t border-b" />
                    <td class="pb-3 pt-3  border-t border-b">Paid Amount</td>
                    <td class="pb-3 pt-3  border-t border-b">
                        <span class="flex items-end px-3 items-end justify-end">{{ customer.paid_amount }}</span>
                    </td>
                </tr>
                <tr class="text-bold font-bold">
                    <td class="pb-3 pt-3  border-t border-b" />
                    <td class="pb-3 pt-3  border-t border-b" />
                    <td class="pb-3 pt-3  border-t border-b" />
                    <td class="pb-3 pt-3  border-t border-b">Balance</td>
                    <td class="pb-3 pt-3  border-t border-b">
                        <span class="flex items-end px-3 items-end justify-end">{{ customer.balance }}</span>
                    </td>
                </tr>
            </table>
        </div>
        <div class="flex p-1 justify-between" style="margin-top: 30px;">
            <table class="w-full border-collapse border-0 border-gray-700 border-slate-700">
                <tbody class="bg-white">
                    <tr>
                        <td>
                            <div class="pb-2 pr-0 w-full lg:w-full">
                                <h2 class="font-bold text-orange-400" style="margin-bottom: 4px;">
                                    PAYMENT INSTRUCTIONS:
                                </h2>
                                <p style="line-height: 24px;">
                                    Our delivery team does not accept cash payments. It's totally our fault
                                    since we have not bought them wallets or a piggy bank. Until we do,
                                    please make your payments via M-pesa upon delivery.
                                </p>
                                <p style="line-height: 24px;">
                                    <strong>paybill Number: {{ customer.pay_bill }}</strong>
                                </p>
                                <p style="line-height: 24px;">
                                    <strong>Account: {{ customer.order_no }}</strong>
                                </p>
                                <p style="line-height: 24px; margin-top: 30px;">
                                    Before our delivery hulks arrive, please ensure you have M-pesa ready to make a payment.
                                </p>
                                <h2 class="font-bold text-orange-400" style="margin-top: 30px; margin-bottom: 4px;">
                                    ADDITIONAL INFORMATION:
                                </h2>
                                <p style="line-height: 24px;">
                                    Deliveries happen between 7am and 6pm. You will receive a call in the morning with a shorter time frame.
                                </p>
                                <p style="line-height: 24px;">
                                    Before we forget: <strong>REFER A FRIEND AND YOU BOTH GET A GIFT!</strong>
                                </p>
                                <p style="line-height: 24px;">
                                    We are excited to get you Mokofied!
                                </p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="w-full items-center" style="margin-bottom: 30px;">
            <h2 class="text-center">
                <i><small>***happy dance***</small></i>
            </h2>
        </div>
    </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    Link,
    Icon,
  },
  layout: Layout,
  props: {
    customer: Object,
    details: Object,
  },
  data() {
    return {
      isOpen: false,
    }
  },
}
</script>